import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LoggingService } from './logging.service';
import { NetworkLogData } from './logging.model';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
    private readonly logger = inject(LoggingService);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const startTime = performance.now();

        return next.handle(req).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        const data: NetworkLogData = {
                            method: req.method,
                            url: req.urlWithParams,
                            status: event.status,
                            durationMs: Math.round(performance.now() - startTime),
                            payload: req.body ?? undefined,
                            response: event.body
                        };
                        this.logger.network(`${req.method} ${req.urlWithParams} → ${event.status}`, data);
                    }
                },
                error: (error) => {
                    const data: NetworkLogData = {
                        method: req.method,
                        url: req.urlWithParams,
                        status: error.status,
                        durationMs: Math.round(performance.now() - startTime),
                        payload: req.body ?? undefined,
                        error: error.message ?? error
                    };
                    this.logger.network(`${req.method} ${req.urlWithParams} → ${error.status} FAILED`, data);
                }
            })
        );
    }
}
